import React from "react";
import { IconButton } from "@mui/material";

export default (props) => <IconButton {...props} style={{ outline: "none", ...props.style }} />; /// Anti bootstrap shit
